import React from "react";
import UniversalAuditTool from "../components/UniversalAuditTool";
export default function UniversalRiskAudit() {
  return <div className="min-h-screen bg-gradient-to-b from-blue-50 via-sky-50 to-white">
    <header className="bg-gradient-to-r from-slate-950 via-blue-950 to-blue-800 text-white">
      <div className="mx-auto max-w-7xl px-5 py-10 md:py-14">
        <p className="text-[11px] font-black uppercase leading-relaxed tracking-[0.14em] text-sky-300 sm:text-xs sm:tracking-[0.22em]">Universal Risk Audit · Free Executive Preview</p>
        <h1 className="mt-4 max-w-4xl text-2xl font-black leading-tight tracking-tight sm:text-3xl md:text-5xl">Discover Potential AI Regulatory Fine Exposure</h1>
        <p className="mt-4 max-w-3xl text-base text-blue-100">Discover the potential financial consequences of AI regulatory noncompliance across the jurisdictions relevant to your business.</p>
        <p className="mt-3 max-w-3xl text-sm text-blue-200">A free executive preview of relevant regulatory penalty frameworks and illustrative financial exposure scenarios, based on the information you provide.</p>
      </div>
    </header>
    <main className="mx-auto max-w-7xl px-5 py-8"><UniversalAuditTool /></main>
  </div>;
}
